import React, { Component } from "react";
import "./banner.scss";
import bannerImage from "../../assets/group-therapy-conversation_179970-1119.jpg";
import { Button } from "@material-ui/core";
// import { Skeleton } from "@material-ui/lab";

class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      loadingTopContent: true,
    };
  }

  render() {
    return (
      <div className="col-12 ">
        <div className="row pt-5">
          <div className="back-image col-lg-7 text-lg-center ">
            <img src={bannerImage} alt="" className="mw-100" />
          </div>
          <div className="content col-lg-5 cnt">
            <h1 className="title desc">گفتگو کلاب</h1>
            <p className="description tlt">
              در گفتگو کودکان زندگی کردن را می آموزند ! اینجا خانه دوم کودکان
              است که در آن یاد می گیرند که به هم عشق بورزند، با هم گفتگو کنند،
              حل مساله داشته باشند، با هم مشارکت کنند و خلاق باشند.
            </p>
            <Button
              variant="contained"
              color="primary"
              className="vazir p-2 pr-5 pl-5 tstBTN"
              style={{ fontFamily: "vazir" }}
              onClick={() => {
                window.scrollBy(0, 400);
              }}
            >
              ادامه
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="vazir p-2 mx-2 pr-5 pl-5 tstBTN"
              style={{ fontFamily: "vazir" }}
              onClick={() => {
                window.location.href = "https://user.goftegooclub.ir/";
              }}
            >
              کلاب کاربران
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Banner;
